export default __webpack_public_path__ + "static/media/html-icon.b2db3a7f.png";